import { CSSResultGroup, TemplateResult, SVGTemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';
import { SlotController } from 'src/components/controllers/slot-controller';
import '../../base/outline-link/outline-link';
import componentStyles from './idb-social-icon-button.css.lit';
import { classMap } from 'lit/directives/class-map.js';

const icons = {
  facebook: `
  <svg viewBox="0 2 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.02 23.88C4.32 22.86 0 17.94 0 12 0 5.4 5.4 0 12 0s12 5.4 12 12c0 5.94-4.32 10.86-10.02 11.88l-.66-.54h-2.64l-.66.54Z"/>
    <path d="m16.68 15.36.54-3.36h-3.18V9.66c0-.96.36-1.68 1.8-1.68h1.56V4.92c-.84-.12-1.8-.24-2.64-.24-2.76 0-4.68 1.68-4.68 4.68V12h-3v3.36h3v8.46a11.048 11.048 0 0 0 3.96 0v-8.46h2.64Z" stroke="currentColor" stroke-width="2"/>
  </svg>
`,
  twitter: `
  <svg viewBox="-3 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.548 20.25c9.057 0 14.01-7.79 14.01-14.545 0-.221-.005-.442-.014-.66A10.235 10.235 0 0 0 24 2.396a9.537 9.537 0 0 1-2.828.805A5.102 5.102 0 0 0 23.338.374a9.658 9.658 0 0 1-3.127 1.241A4.836 4.836 0 0 0 16.617 0c-2.72 0-4.925 2.29-4.925 5.111 0 .402.044.792.128 1.166C7.728 6.063 4.1 4.029 1.67.936a5.249 5.249 0 0 0-.667 2.57c0 1.773.87 3.339 2.192 4.255a4.751 4.751 0 0 1-2.23-.64l-.001.065c0 2.476 1.697 4.543 3.95 5.012a4.765 4.765 0 0 1-2.224.087c.627 2.032 2.445 3.51 4.6 3.551A9.65 9.65 0 0 1 0 17.953a13.568 13.568 0 0 0 7.548 2.297" stroke="currentColor" stroke-width="2" />
  </svg>
  `,
  instagram: `
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.999 3.14c-2.406 0-2.708.011-3.653.054-.944.043-1.587.193-2.15.412a4.338 4.338 0 0 0-1.57 1.022 4.35 4.35 0 0 0-1.023 1.57c-.22.563-.369 1.207-.411 2.15-.042.946-.054 1.248-.054 3.655s.011 2.708.054 3.653c.043.944.193 1.588.412 2.151a4.337 4.337 0 0 0 1.021 1.57c.493.493.987.797 1.57 1.023.563.22 1.207.369 2.15.412.945.043 1.247.053 3.653.053 2.406 0 2.707-.01 3.652-.053.944-.044 1.588-.193 2.152-.412a4.335 4.335 0 0 0 1.568-1.023 4.35 4.35 0 0 0 1.023-1.57c.218-.563.367-1.207.412-2.15.042-.946.053-1.247.053-3.654s-.011-2.709-.053-3.654c-.045-.944-.194-1.588-.412-2.151a4.35 4.35 0 0 0-1.023-1.57 4.33 4.33 0 0 0-1.569-1.022c-.564-.22-1.209-.369-2.152-.412-.945-.043-1.246-.053-3.653-.053H12Zm-.795 1.598H12c2.365 0 2.646.008 3.58.05.864.04 1.333.185 1.645.306.413.16.708.352 1.018.663.31.31.502.605.663 1.019.121.312.266.78.305 1.645.043.934.052 1.215.052 3.58s-.01 2.646-.052 3.58c-.04.864-.184 1.333-.305 1.645a2.74 2.74 0 0 1-.663 1.018 2.74 2.74 0 0 1-1.018.663c-.312.122-.781.266-1.645.305-.934.043-1.215.052-3.58.052-2.366 0-2.646-.01-3.58-.052-.864-.04-1.333-.184-1.645-.305a2.744 2.744 0 0 1-1.02-.663 2.747 2.747 0 0 1-.662-1.019c-.122-.312-.266-.78-.305-1.645-.043-.934-.051-1.215-.051-3.581 0-2.367.008-2.646.05-3.58.04-.864.184-1.333.306-1.646.16-.413.353-.709.663-1.019a2.75 2.75 0 0 1 1.019-.663c.312-.122.78-.266 1.645-.306.817-.037 1.134-.048 2.785-.05v.003Zm5.524 1.471a1.063 1.063 0 1 0 0 2.126 1.063 1.063 0 0 0 0-2.126Zm-4.73 1.243a4.55 4.55 0 1 0 .003 9.101 4.55 4.55 0 0 0-.002-9.101Zm0 1.597a2.954 2.954 0 1 1 0 5.907 2.954 2.954 0 0 1 0-5.907Z" fill="currentColor"/>
  </svg>
  `,
  linkedin: `
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path stroke-width="1.5" stroke="currentColor" d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect stroke-width="1.5" stroke="currentColor" x="2" y="9" width="4" height="12"></rect><circle stroke-width="1.5" stroke="currentColor" cx="4" cy="4" r="2"></circle>
  </svg>
  `,
  youtube: `
  <svg viewBox="-1 0 36 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M33.39 3.748A4.282 4.282 0 0 0 30.375.717C27.715 0 17.051 0 17.051 0S6.387 0 3.728.717a4.282 4.282 0 0 0-3.015 3.03C0 6.423 0 12 0 12s0 5.579.713 8.253a4.282 4.282 0 0 0 3.015 3.03C6.388 24 17.05 24 17.05 24s10.665 0 13.324-.716a4.283 4.283 0 0 0 3.015-3.031c.713-2.675.713-8.253.713-8.253s0-5.578-.713-8.252Z" stroke-width="2" stroke="currentColor" fill="transparent"/>
    <path d="M13.563 17.063 22.476 12l-8.913-5.065v10.13Z" fill="currentColor"/>
  </svg>
  `,
  mail: `
  <svg viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
    <polyline points="22,6 12,13 2,6" stroke="currentColor"></polyline>
  </svg>
  `,
};

export type SocialIconType = keyof typeof icons;

export const iconsArr: SocialIconType[] = Object.keys(
  icons
) as SocialIconType[];

/**
 * The Idb Social Icon button component
 * @element idb-social-icon-button
 */
@customElement('idb-social-icon-button')
export class IdbSocialIcon extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotController(this, false);

  @property({ type: String, attribute: 'icon' })
  icon: SocialIconType;

  /**
   * The social media url that the icon will link to
   */
  @property({ type: String, attribute: 'url' })
  url: string;

  /**
   * The aria label for the link
   */
  @property({ type: String, attribute: 'link-aria-label' })
  linkAriaLabel: string;

  /**
   * If this icon is used in the footer
   */
  @property({ type: Boolean, attribute: 'footer' })
  footer: boolean;

  protected firstUpdated(): void {
    if (!this.icon) {
      throw new Error('icon is required');
    } else if (!this.url) {
      throw new Error('url is required');
    } else if (!this.linkAriaLabel) {
      throw new Error('link-aria-label is required for accessibility');
    }

    this.addEventListener('click', () => {
      window.open(this.url, '_blank');
    });
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();

    this.removeEventListener('click', () => {
      window.open(this.url, '_blank');
    });
  }

  render(): TemplateResult {
    const wrapperClasses = classMap({
      'wrapper': true,
      'social-icon--footer': this.footer,
      [this.icon]: true,
    });

    return html`
    <div class="${wrapperClasses}">
      <outline-link
      link-href=${this.url}
      link-target="_blank"
      link-aria-label=${this.linkAriaLabel}
      >
        <div class="icon ${this.icon}">
          ${unsafeSVG(icons[this.icon]) as SVGTemplateResult}
        </div>
    </outline-link>
  </div>
    `;
  }
}
